import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';
import { Props } from './types';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader
        viewBox="0 0 400 60"
        backgroundColor="#f1f1f1"
        $opacity={opacity}
      >
        <circle cx="20" cy="20" r="15" />
        <rect x="53" y="12" rx="7" ry="7" width="120" height="15" />
        <rect x="225" y="12" rx="7" ry="7" width="120" height="15" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
